import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-group_02",
  "use": "icon-group_02-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-group_02\"><defs><style type=\"text/css\"></style></defs><path d=\"M704 864h-512c-89.6 0-160-70.4-160-160v-512c0-89.6 70.4-160 160-160h512c89.6 0 160 70.4 160 160v512c0 89.6-70.4 160-160 160z m-512-768c-51.2 0-96 44.8-96 96v512c0 51.2 44.8 96 96 96h512c51.2 0 96-44.8 96-96v-512c0-51.2-44.8-96-96-96h-512z\" p-id=\"14120\" /><path d=\"M832 992h-512c-19.2 0-32-12.8-32-32s12.8-32 32-32h512c51.2 0 96-44.8 96-96v-512c0-19.2 12.8-32 32-32s32 12.8 32 32v512c0 89.6-70.4 160-160 160z\" p-id=\"14121\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/group_02.svg
// module id = YmaR
// module chunks = 22